import React, { ComponentType } from 'react';
import { useFileIntelligenceEnabled } from 'hooks/file-intelligence-settings-hooks';

/**
 * Higher-Order Component that provides the firm's File Intelligence setting
 * to class components as the `fileIntelligenceEnabled` prop.
 */
export const withFileIntelligenceSetting = <P extends object>(
  WrappedComponent: ComponentType<
    P & { fileIntelligenceEnabled?: boolean; fileIntelligenceLoading?: boolean }
  >,
) => {
  const WithFileIntelligenceSettingComponent = (props: P) => {
    const { isFileIntelligenceEnabled, isLoading } =
      useFileIntelligenceEnabled();

    return (
      <WrappedComponent
        {...props}
        fileIntelligenceEnabled={isFileIntelligenceEnabled}
        fileIntelligenceLoading={isLoading}
      />
    );
  };

  WithFileIntelligenceSettingComponent.displayName = `withFileIntelligenceSetting(${
    WrappedComponent.displayName || WrappedComponent.name || 'Component'
  })`;

  return WithFileIntelligenceSettingComponent;
};

export default withFileIntelligenceSetting;
